var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled, { useTheme } from "styled-components";
import { Box } from "../../Box";
import { Flex } from "../../Flex";
import { Icon } from "../../Icon";
import { Tooltip } from "../../Tooltip";
import { Text } from "../../Text";
import { Button } from "../../Button";
const Arrow = styled.div `
  position: absolute;
  top: -17px;
  left: 50%;
  width: 25px;
  height: 25px;

  &::after {
    content: " ";
    position: absolute;
    top: 0;
    left: 19px;
    box-sizing: border-box;
    width: 25px;
    height: 25px;
    box-shadow: inset 1px 1px 5px 0
      ${({ theme: { colors: { detailsAreaColors }, }, }) => detailsAreaColors.shadowColor};
    background-color: ${({ theme: { colors: { detailsAreaColors }, }, }) => detailsAreaColors.background};
    transform: rotate(45deg);
    transform-origin: 0 0;
  }

  &::before {
    content: " ";
    position: absolute;
    top: 14px;
    left: 1px;
    background-color: ${({ theme: { colors: { detailsAreaColors }, }, }) => detailsAreaColors.background};
    width: 36px;
    height: 21px;
    border-radius: 50%;
    z-index: 1;
  }
`;
const CloseButton = ({ onClose, "data-testid": testId }) => (React.createElement(Button, { "data-testid": testId, onClick: onClose, variant: "iconWithoutBorder", size: "noPadding", textStyle: "greyIcon" },
    React.createElement(Icon, { src: "Close", size: "16px" })));
export const DetailsArea = (_a) => {
    var { title, icon, showExpandedArrow, open, "data-testid": testId = "detailsArea", onClose, children, closeButtonTooltipText } = _a, props = __rest(_a, ["title", "icon", "showExpandedArrow", "open", "data-testid", "onClose", "children", "closeButtonTooltipText"]);
    const { colors: { detailsAreaColors }, } = useTheme();
    return (React.createElement(Box, Object.assign({ "data-testid": testId, position: "relative", backgroundColor: detailsAreaColors.background, mt: "25px", mx: "-18px", mb: "40px", py: "25px", px: "50px", boxShadow: `inset  0  8px 8px -8px ${detailsAreaColors.shadowColor}, inset  0 -8px 8px -8px ${detailsAreaColors.shadowColor}`, display: open ? "block" : "none" }, props),
        showExpandedArrow && React.createElement(Arrow, { "data-testid": `${testId}ExpandedArrow` }),
        React.createElement(Flex, { justifyContent: "space-between", alignItems: "center", mb: "22px" },
            React.createElement(Flex, { alignItems: "center", color: detailsAreaColors.titleIconColor },
                icon && (React.createElement(Box, { mr: 2, mt: 1 },
                    React.createElement(Icon, { src: icon, "data-testid": `${testId}Icon`, size: "16px" }))),
                React.createElement(Text, { "data-testid": `${testId}Title`, ml: 1, textStyle: "detailsArea" }, title)),
            React.createElement(Tooltip, { content: closeButtonTooltipText, placement: "left" },
                React.createElement("span", null,
                    React.createElement(CloseButton, { onClose: onClose, "data-testid": `${testId}CloseButton` })))),
        children));
};
